module.exports = __webpack_public_path__ + "img/wx.99564396.png";